module.exports = __webpack_public_path__ + "img/32.bcf4eb23.png";